import './App.css'
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from 'react-router-dom'
import { useEffect, useState } from 'react'
import ForgotPassword from './screen/AuthFrom/ForgotPassword'
import SetResetPassword from './screen/AuthFrom/SetResetPassword'
import Box from '@mui/material/Box'
import Dashboard from './screen/Dashboard/Dashboard'
import ArtCategory from './screen/CategoryManagement/ArtCategory'
import UserManagement from './screen/UserManagement/UserManagement'
import UserProfile from './screen/UserManagement/UserProfile/UserProfile'
import EventsManagement from './screen/EventsManagement/EventsManagement'
import SubscriptionManagement from './screen/Subscription/SubscriptionManagement'
import EventDetails from './screen/EventsManagement/EventDetails/EventDetails'
import Subcategory from './screen/CategoryManagement/Subcategory/Subcategory'
import { useSelector } from 'react-redux'




import SubMasterEvents from './screen/EventsManagement/SubMasterEvents'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import SetForgotPassword from './screen/AuthFrom/SetForgotPassword'
import UserUpdate from './screen/UserManagement/UserTab/UserList/UserUpdate/UserUpdate'

import Achievements from './screen/Achievement/Achievements'
import AddAchievements from './screen/Achievement/AddAchievements'
import Registration from './screen/Registration/Registration'
import CustomSideBar from './Components/CustomSideBar/CustomSideBar'
import Login from './screen/AuthFrom/Login'
import UserApplication from './screen/UserApplication/UserApplication'
import ArtLover from './screen/UserManagement/ArtLover/ArtLover'
import Artist from './screen/UserManagement/Artist/Artist'
import ArtistPro from './screen/UserManagement/ArtistPro/ArtistPro'
import ArtRunner from './screen/UserManagement/ArtRunner/ArtRunner'
import CustomEventUpdate from './screen/EventsManagement/EventUpdate/CustomEventUpdate'
import Loader from './Components/Loader/Loader'
import { FormProvider } from './screen/EventsManagement/EventUpdate/FormProvider'

import ArtisticTag from './screen/ArtisticTag/ArtisticTag'
import ReferralManagement from './screen/UserManagement/ReferralManagement/ReferralManagement'
import WithOutCheckInEvent from './screen/EventsManagement/WithOutCheckInEvent'




import WalletFunds from './screen/wallerFunds/walletFunds'
import BookedEvents from './screen/BookedEvent/bookedEvent'
import PlatformSetting from './screen/PlatformSetting/platformSetting'
import ArtrunerWallet from './screen/artrunerWallet/artrunerWallet'
import CustomEventRepeat from './screen/EventsManagement/EventUpdate/CustomEventRepeat'
import MasterEvents from './screen/EventsManagement/MasterEvents'
import AdminEvents from './screen/EventsManagement/AdminEvent'


function App() {
  const routes = [
    { path: '/', element: <Dashboard /> },
    { path: '/ArtCategory', element: <ArtCategory /> },
    { path: '/ArtisticTag', element: <ArtisticTag /> },
    { path: '/UserManagement', element: <UserManagement /> },
    { path: '/UserProfile', element: <UserProfile /> },
    { path: '/SubMasterEvents/:id', element: <SubMasterEvents /> },
    { path: '/Achievements', element: <Achievements /> },
    { path: '/EventDetails', element: <EventDetails /> },
    { path: '/AddAchievements', element: <AddAchievements /> },
    { path: '/Subcategory', element: <Subcategory /> },
    { path: '/Registration', element: <Registration /> },
    { path: '/UserApplication', element: <UserApplication /> },
    { path: '/UserUpdate', element: <UserUpdate /> },

    // ─── All event chip routes → single EventsManagement ───────────────────
    { path: '/EventsManagement', element: <EventsManagement /> },
    { path: '/MasterEvents',     element: <MasterEvents /> },
    { path: '/TodayEvents',      element: <EventsManagement /> },
    { path: '/UpcomingEvent',    element: <EventsManagement /> },
    { path: '/PastEvent',        element: <EventsManagement /> },
    { path: '/AdminEvents',      element: <AdminEvents /> },
    { path: '/SubmitedEvent',    element: <WithOutCheckInEvent /> },

    // ─── All subscription chip routes → single SubscriptionManagement ──────
    { path: '/PlanList',         element: <SubscriptionManagement /> },
    { path: '/Memberships',      element: <SubscriptionManagement /> },
    { path: '/Ambassador',       element: <SubscriptionManagement /> },
    { path: '/AmbassadorTrack',  element: <SubscriptionManagement /> },
    { path: '/History',          element: <SubscriptionManagement /> },
    { path: '/SetResetPassword', element: <SetResetPassword /> },
    { path: '/ArtLover', element: <ArtLover /> },
    { path: '/Artist', element: <Artist /> },
    { path: '/ArtistPro', element: <ArtistPro /> },
    { path: '/ArtRunner', element: <ArtRunner /> },
    { path: '/ReferralManagement', element: <ReferralManagement /> },
    { path: '/walletFunds', element: <WalletFunds /> },
    { path: '/BookedEvents', element: <BookedEvents /> },
    { path: '/PlatformSetting', element: <PlatformSetting /> },
    { path: '/ArtrunnerWallet', element: <ArtrunerWallet /> },
    { path: '/EventUpdate', element: (<FormProvider> <CustomEventUpdate /> </FormProvider>) },
    { path: '/EventRepeat', element: (<FormProvider> <CustomEventRepeat /> </FormProvider>) },
    { path: '/User', element: <Navigate to='/ArtLover' replace={true} /> },
    { path: '/ArtLoverOnly', element: <ArtLover /> },
  ]

  const isProfileData = useSelector(state => state.isProfileData)
  const [forgotNavigate, setForgotNavigate] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(
    isProfileData == null ? false : true
  )
  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn')
    if (isLoggedIn) {
      setIsLoggedIn(JSON.parse(isLoggedIn))
    }
  }, [isLoggedIn])

  if (process.env.NODE_ENV == 'production') {
    document.addEventListener('contextmenu', event => event.preventDefault())
    document.addEventListener('keydown', event => {
      if (
        event.key === 'F12' ||
        (event.ctrlKey && event.shiftKey && event.key === 'I')
      ) {
        event.preventDefault()
      }
    })
  }

  return (
    <div className='min-screen-color'>
      {isProfileData ? (
        <div className='screen-color'>
          <Box className='screen-box-flex'>
            <CustomSideBar />
            <main className='min-screen-width'>
              <Routes>
                {routes.map(({ path, element }, index) => (
                  <Route key={index} path={path} element={element} />
                ))}
                <Route path='*' element={<Navigate to='/' replace={true} />} />
              </Routes>
            </main>
          </Box>
        </div>
      ) : (
        <Routes>
          <Route
            path='/'
            element={
              <Login
                setIsLoggedIn={setIsLoggedIn}
                setForgotNavigate={setForgotNavigate}
              />
            }
          />
          {forgotNavigate && (
            <Route path='/ForgotPassword' element={<ForgotPassword />} />
          )}
          {forgotNavigate && (
            <Route path='/SetForgotPassword' element={<SetForgotPassword />} />
          )}
          <Route
            path='*'
            element={
              <Navigate to='/' replace={true} setIsLoggedIn={setIsLoggedIn} />
            }
          />
        </Routes>
      )}
      <Loader />

      <ToastContainer />
    </div>
  )
}

export default App